<!-- Responsibility: Implement player profile list section behavior for the ui/components surface.
Scope: Owns ui/components concerns only; cross-surface orchestration is excluded. -->

<player-profile-list-section>
  <section class="pp-section" if={ props.entries && props.entries.length }>
    <h5 class="pp-section-title">{ props.title }</h5>

    <div class="pp-list">
      <div
        each={ entry in props.entries }
        class="pp-list-item"
        role="button"
        tabindex="0"
        aria-label={ `Open ${props.itemLabel || 'entry'} ${entry.name}` }
        onclick={ () => props.onOpen && props.onOpen(entry) }
        onkeydown={ (e) => props.onActivateKey && props.onActivateKey(e, () => props.onOpen && props.onOpen(entry)) }
      >
        <div class="pp-list-main">
          <span class="pp-list-name">{ props.prefix || '' } { entry.name.toUpperCase() }</span>
          <span class="pp-list-meta">{ entry.meta }</span>
        </div>
        <div class="pp-list-desc">{ entry.desc }</div>
      </div>
    </div>
    <p if={ props.overflowCount > 0 } class="pp-overflow-note">+{ props.overflowCount } more { String(props.title || 'entries').toLowerCase() } hidden for stable rendering.</p>
  </section>

  <style>
    .pp-section { animation: section-in 0.5s ease both; }
    .pp-section-title { color: var(--text-dim); font-size: var(--space-sm); letter-spacing: 0.25em; margin: 0 0 1.25rem; border-bottom: 1px solid var(--border); padding-bottom: var(--space-xs); }
    .pp-list { display: flex; flex-direction: column; gap: var(--space-sm); }
    .pp-list-item {
      background: rgba(0,0,0,0.3); border: 1px solid var(--border); border-radius: 0.25rem; padding: var(--space-md); transition: all 0.2s; cursor: pointer;
    }
    .pp-list-item:hover { border-color: var(--gold); background: rgba(0,0,0,0.5); transform: translateX(0.25rem); }
    .pp-list-main { display: flex; justify-content: space-between; align-items: baseline; margin-bottom: var(--space-xs); gap: var(--space-md); }
    .pp-list-name { color: var(--gold); font-weight: bold; font-size: 0.9rem; letter-spacing: 0.05em; }

    .pp-list-meta { font-size: 0.65rem; color: var(--text-dim); font-weight: bold; }
    .pp-list-desc { font-size: 0.85rem; color: var(--text-muted); line-height: 1.4; }
    .pp-overflow-note { margin: var(--space-xs) 0 0; color: color-mix(in srgb, var(--text-muted) var(--alpha-high), #dbe8ff); font-size: var(--space-sm); letter-spacing: 0.03em; }
  </style>
</player-profile-list-section>
